/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1443
 */

var r = require(/* 1444 */"../2546/1456/1444")
var i = require(/* 451 */"../../../../2466/2467/451")
module.exports = function (e, t, n) {
  var o = t(e)
  return i(e) ? o : r(o, n(e))
}
